import { ImageOff, Sparkles } from 'lucide-react';
import { Alert, AlertDescription } from '@/components/ui/alert';

export const IMAGE_ISSUE_BANNER_HEIGHT = 52; // Export for use in layouts

export function ImageIssueBanner() {
  // This banner is always visible to inform users about temporary image loading issues
  const showBanner = false; // Set to false when images are fixed

  if (!showBanner) {
    return null;
  }

  return (
    <Alert
      className="fixed top-0 left-0 right-0 z-[60] rounded-none border-0 border-b border-brand-gold-accent bg-gradient-to-r from-brand-gold-accent via-brand-gold to-brand-gold-accent text-white shadow-md"
      style={{ height: `${IMAGE_ISSUE_BANNER_HEIGHT}px` }}
    >
      <div className="flex items-center justify-center gap-3 w-full">
        <ImageOff className="h-5 w-5 text-white flex-shrink-0 animate-pulse" />
        <AlertDescription className="font-medium text-center text-sm md:text-base flex items-center gap-2">
          <span>Estamos actualizando nuestras imágenes</span>
          <Sparkles className="h-4 w-4 text-white/80 inline-block animate-pulse" />
          <span className="hidden sm:inline">•</span>
          <span className="text-white/90">Disculpa las molestias</span>
        </AlertDescription>
      </div>
    </Alert>
  );
}
